export type Locale = 'en' | 'ja'

export type CeramicObject = {
  id: string
  slug: string
  name: string
  nameJa: string
  series: 'RITUAL' | 'TABLE'
  form: string
  maker: string
  makerSlug: string
  kiln: string
  firing: string
  material: string
  dimensions: string
  description: string
  story: string
  batch: string
  status: 'published' | 'opening_soon'
  tone: string
}

export const objects: CeramicObject[] = [
  {
    id: 'obj-001', slug: 'quiet-incense-holder', name: 'Quiet Incense Holder', nameJa: '静かな香立て', series: 'RITUAL', form: 'Incense holder', maker: 'Atelier Lin', makerSlug: 'atelier-lin', kiln: 'South River Kiln', firing: 'Wood firing · 1280°C', material: 'Jingdezhen porcelain, ash glaze', dimensions: 'Ø 72 × H 42 mm',
    description: 'A low porcelain form for the first ember of the day.', story: 'The opening in the clay is sized for a single stick. Ash settles into a shallow basin, leaving each firing with its own quiet record.', batch: 'KL-RI-2401', status: 'published', tone: 'sand'
  },
  {
    id: 'obj-002', slug: 'blue-hour-cup', name: 'Blue Hour Cup', nameJa: '蓝调时刻杯', series: 'TABLE', form: 'Tea cup', maker: 'Yao Studio', makerSlug: 'yao-studio', kiln: 'East Gate Kiln', firing: 'Gas firing · 1260°C', material: 'Porcelain, cobalt wash', dimensions: 'Ø 82 × H 58 mm · 150 ml',
    description: 'A small cup whose blue wash holds the edge of dusk.', story: 'The surface is brushed by hand over a pale body. Variations in the wash are part of the record, not a defect to remove.', batch: 'KL-TA-2402', status: 'published', tone: 'blue'
  },
  {
    id: 'obj-003', slug: 'field-plate', name: 'Field Plate', nameJa: '原野盘', series: 'TABLE', form: 'Side plate', maker: 'Ming Workshop', makerSlug: 'ming-workshop', kiln: 'North Ridge Kiln', firing: 'Electric firing · 1240°C', material: 'Stoneware, iron slip', dimensions: 'Ø 190 × H 24 mm',
    description: 'A spare plate for fruit, bread, and the things between meals.', story: 'A thin iron line follows the rim by hand. The plate is made to gather the small, everyday arrangements that are easy to miss.', batch: 'KL-TA-2403', status: 'opening_soon', tone: 'clay'
  },
  {
    id: 'obj-004', slug: 'folded-light-candle-stand', name: 'Folded Light Candle Stand', nameJa: '折光烛台', series: 'RITUAL', form: 'Candle stand', maker: 'Atelier Lin', makerSlug: 'atelier-lin', kiln: 'South River Kiln', firing: 'Wood firing · 1280°C', material: 'Porcelain, clear glaze', dimensions: 'Ø 64 × H 88 mm',
    description: 'A small architecture for a steady flame.', story: 'The folded silhouette catches the light without asking for attention. It is a study in balance, edge and the space around an object.', batch: 'KL-RI-2404', status: 'opening_soon', tone: 'cream'
  }
]

export const journal = [
  { slug: 'how-to-read-a-batch', tag: 'TRACE / 01', title: 'How to read a batch record', titleJa: '批次记录的阅读方式', excerpt: 'A batch is not a marketing line. It is the smallest shared record of clay, kiln, maker and time.', date: '2026.10.06', read: '6 min read' },
  { slug: 'the-blue-hour-cup', tag: 'OBJECT / 02', title: 'The blue hour cup', titleJa: '蓝调时刻杯', excerpt: 'On a cobalt wash, the hand, the water and the temperature remain visible together.', date: '2026.10.01', read: '4 min read' },
  { slug: 'four-questions-before-a-piece', tag: 'METHOD / 03', title: 'Four questions before a piece', titleJa: '一件器物之前的四个问题', excerpt: 'Who made it? Where was it fired? Which batch is it from? What can it honestly promise?', date: '2026.09.24', read: '5 min read' }
]

export const makers = [
  { slug: 'atelier-lin', name: 'Atelier Lin', place: 'Jingdezhen · South River', note: 'Quiet forms, wood ash, and the patience of repetition.' },
  { slug: 'yao-studio', name: 'Yao Studio', place: 'Jingdezhen · East Gate', note: 'Porcelain surfaces built from water, cobalt and restraint.' },
  { slug: 'ming-workshop', name: 'Ming Workshop', place: 'Jingdezhen · North Ridge', note: 'Everyday tableware with a drawn, human edge.' }
]

export const batchRecords: Record<string, { kiln: string; firing: string; maker: string; method: string; recorded: string; note: string }> = {
  'KL-RI-2401': { kiln: 'South River Kiln', firing: '1280°C', maker: 'Atelier Lin', method: 'Wood firing', recorded: '2026.08.12', note: 'Public record: glaze and firing details verified by the maker.' },
  'KL-TA-2402': { kiln: 'East Gate Kiln', firing: '1260°C', maker: 'Yao Studio', method: 'Gas firing', recorded: '2026.08.21', note: 'Public record: surface variation documented in the object notes.' },
  'KL-TA-2403': { kiln: 'North Ridge Kiln', firing: '1240°C', maker: 'Ming Workshop', method: 'Electric firing', recorded: '2026.09.03', note: 'Public record: opening soon; sales and inventory are not active.' }
}
